import { useState, useEffect } from "react";

import React from "react";
import "../../assets/index.less";
import "./financial.css";

import TransactionHistory from "./TransactionHistory";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import sendRequest from "hooks/useAxios";
import Pagination from "rc-pagination";
import { ProductsOrder } from "common/order/ProductsOrder";
import { ProductsRepair } from "common/order/ProductsRepair";
import ComplatePriceModalAdmin from "common/order/ComplatePriceModalAdmin";
import StatusReportModal from "common/order/StatusReportModal";
function Financialtabs({
  transactionsLists,
  allOrder,
  newOrder,
  debtOrder,
  setUpdater,
  updater,
}) {
  const [newFactor, setNewFactor] = useState([
    {
      receiveTime: "1401/01/01",
      deliverTime: "1401/01/11",
      price: "145000",
      typeOfPay: "آفلاین",
      username: "علی احمدی",
      machineName: "ایسوس",
      machineModel: "notebook",
      trackingNumber: "12345",
      description: "متن ساختگی ... ",
    },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState({});

  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    // setChatList(information.chats);
  };

  return (
    <>
      <div className="container financial-tabs">
        <UpdateRepairModal selectedItem={selectedItem}></UpdateRepairModal>
        <UpdateOrderModal
          selectedItem={selectedItem}
          updateSelectedItem={updateSelectedItem}
        ></UpdateOrderModal>
        <ComplatePriceModalAdmin
          selectedItem={selectedItem}
          setUpdaterList={setUpdater}
        />
        <StatusReportModal
          selectedItem={selectedItem}
          pageType="0"
          // chats={selectedItem.chats}
          // chats={chatList}
          // setChats={setChatList}
        ></StatusReportModal>
        <ul className="nav nav-tabs mt-5" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active text-red"
              id="newfactor-tab"
              data-bs-toggle="tab"
              data-bs-target="#newfactor"
              type="button"
              role="tab"
              aria-controls="newfactor"
              aria-selected="true"
            >
              فاکتورهای جدید
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="debtorfactors-tab"
              data-bs-toggle="tab"
              data-bs-target="#debtorfactors"
              type="button"
              role="tab"
              aria-controls="debtorfactors"
              aria-selected="false"
            >
              فاکتورهای بدهکار
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="allFactors-tab"
              data-bs-toggle="tab"
              data-bs-target="#allFactors"
              type="button"
              role="tab"
              aria-controls="allFactors"
              aria-selected="false"
            >
              همه
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="transaction-tab"
              data-bs-toggle="tab"
              data-bs-target="#transaction"
              type="button"
              role="tab"
              aria-controls="transaction"
              aria-selected="false"
            >
              تاریخچه تراکنش
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="newfactor"
            role="tabpanel"
            aria-labelledby="newfactor-tab"
          >
            <div className="order-container">
              {newOrder
                .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
                .map((value, index) => {
                  if (value.type == "0") {
                    return (
                      <ProductsOrder
                        data={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        selectedItem={selectedItem}
                        pageType="admin"
                        setUpdaterList={setUpdater}
                      ></ProductsOrder>
                    );
                  } else {
                    return (
                      <ProductsRepair
                        data2={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        pageType="admin"
                      ></ProductsRepair>
                    );
                  }
                })}
              <div className="d-flex justify-content-center mt-4">
                <div>
                  <Pagination
                    total={newOrder.length}
                    pageSize={5}
                    current={currentPage}
                    onChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                  ></Pagination>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="debtorfactors"
            role="tabpanel"
            aria-labelledby="debtorfactors-tab"
          >
            <div className="order-container">
              {debtOrder
                .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
                .map((value, index) => {
                  if (value.type == "0") {
                    return (
                      <ProductsOrder
                        data={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        pageType="admin"
                        setUpdaterList={setUpdater}
                        selectedItem={selectedItem}
                      ></ProductsOrder>
                    );
                  } else {
                    return (
                      <ProductsRepair
                        data2={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        pageType="admin"
                      ></ProductsRepair>
                    );
                  }
                })}
              <div className="d-flex justify-content-center mt-4">
                <div>
                  <Pagination
                    total={debtOrder.length}
                    pageSize={5}
                    current={currentPage}
                    onChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                  ></Pagination>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="allFactors"
            role="tabpanel"
            aria-labelledby="allFactor-tab"
          >
            <div className="order-container">
              {allOrder
                .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
                .map((value, index) => {
                  if (value.type == "0") {
                    return (
                      <ProductsOrder
                        data={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        pageType="admin"
                        setUpdaterList={setUpdater}
                        selectedItem={selectedItem}
                      ></ProductsOrder>
                    );
                  } else {
                    return (
                      <ProductsRepair
                        data2={value}
                        index={index}
                        updateSelectedItem={updateSelectedItem}
                        pageType="admin"
                      ></ProductsRepair>
                    );
                  }
                })}
              <div className="d-flex justify-content-center mt-4">
                <div>
                  <Pagination
                    total={allOrder.length}
                    pageSize={5}
                    current={currentPage}
                    onChange={(newPage) => {
                      setCurrentPage(newPage);
                    }}
                  ></Pagination>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="transaction"
            role="tabpanel"
            aria-labelledby="transaction-tab"
          >
            {/* تاریخچه تراکنش */}
            <TransactionHistory
              setUpdater={setUpdater}
              updater={updater}
            ></TransactionHistory>
          </div>
        </div>
      </div>
    </>
  );
}
export default Financialtabs;
